export default __webpack_public_path__ + "static/media/drop.bcdb663c.svg";